// extracted by mini-css-extract-plugin
export default {"editor":"memoInput_editor__6EQZS","toolbar":"memoInput_toolbar__6AhYO"};